export function objectMap(object, function_) {
    return Object.fromEntries(
        Object.entries(object).map(
            ([k, v], i) => [k, function_(v, k, i)],
        ),
    );
}

export function objectSplice(object, start, end = null) {
    const entries = Object.entries(object);

    const slicedEntries = end !== null && end !== undefined ? entries.slice(start, end) : entries.slice(start);

    return Object.fromEntries(slicedEntries);
}
